import { Link } from "react-router-dom";
import { ArrowUp } from "@phosphor-icons/react";
import { contact, images, navLinks } from "@/data/site";

export function Footer() {
  return (
    <footer className="border-t border-industrial-line" data-testid="site-footer">
      <div className="mx-auto grid max-w-[1500px] gap-10 px-5 py-12 sm:px-8 lg:grid-cols-[1fr_1.3fr_0.7fr]">
        <div>
          <img src={images.logo} alt="Shyam Equipment and Infratech" className="h-14 w-auto object-contain" />
          <p className="mt-5 max-w-sm text-sm leading-7 text-industrial-muted">Engineering Excellence, Equipment Reliability. PAN India manpower, machinery, and transaction support.</p>
          <a href={contact.profilePdf} download="Shyam-Equipment-Infratech-Company-Profile.pdf" data-testid="footer-download-profile-link" className="mt-4 inline-flex items-center gap-2 border border-industrial-yellow px-4 py-2.5 font-mono text-[11px] font-bold uppercase tracking-[0.18em] text-industrial-text transition-colors hover:bg-industrial-yellow">
            Company Profile (PDF) <span aria-hidden="true">↓</span>
          </a>
        </div>
        <div className="grid gap-3 sm:grid-cols-2">
          {navLinks.map((link) => <Link key={link.href} to={link.href} data-testid={`footer-${link.testId}`} className="font-mono text-xs uppercase tracking-[0.18em] text-industrial-muted transition-colors hover:text-industrial-yellow">{link.label}</Link>)}
        </div>
        <div className="lg:text-right">
          <Link to="/" data-testid="footer-back-to-top-link" className="inline-flex h-12 w-12 items-center justify-center border border-industrial-line text-industrial-yellow transition-colors hover:border-industrial-yellow"><ArrowUp size={20} weight="bold" /></Link>
          <p className="mt-5 font-mono text-xs leading-6 text-industrial-muted">{contact.phone}<br />{contact.email}</p>
        </div>
      </div>
      <div className="border-t border-industrial-line py-5 text-center font-mono text-[11px] uppercase tracking-[0.18em] text-industrial-muted" data-testid="footer-copyright">
        © 2026 Shyam Equipment and Infratech · Engineering Excellence, Equipment Reliability
      </div>
    </footer>
  );
}
